import { getWeekSeconds } from "./getWeekSeconds";

export const getNextWorkingDay = (seconds: number) => {
  let newSeconds = seconds + 86400; // jump to tomorrow

  const mondaySeconds = getWeekSeconds(newSeconds);
  const secondsFromMonday = newSeconds - mondaySeconds;

  //  Jump to next week if its Friday or later
  const fiveDaysInSeconds = 86400 * 5;
  if (secondsFromMonday >= fiveDaysInSeconds)
    newSeconds = mondaySeconds + 604800;

  return newSeconds;
};
